import client from "api/client";

import type { SearchApi } from "api/models/index";
import type { ProfileUser } from "api/models/user";
import type { ContentEdit, ContentInfoApi, ContentSearch } from "api/models/content";


const base = "/admin/content";
const content = {
	get: (id: number) => client.get<ContentInfoApi>(base + `/${id}`),
	edit: (id: number, body: ContentEdit) => client.post<ContentInfoApi>(base + `/${id}`, body),
	history: (body: SearchApi<ProfileUser>) => client.post<ContentInfoApi[]>(base + "/history", body, { paginated: true }),
	undo: (userId: number, scuId: number) => client.post<ContentInfoApi[]>(base + "/undo", { userId, scuId }),
	search: (body: SearchApi<ContentSearch>) => client.post<ContentInfoApi[]>(base + "/search", body, { paginated: true }),
	setFeatured: (id: number, value: boolean) => client.post<ContentInfoApi>(base + `/featured/${id}`, value)
};

export default content;